// libs
import { styled } from '@nykaa/ui-components';
import { BREAKPOINTS } from 'shared/styles/base';

// components
import GradientText from 'shared/components/GradientText';

export const Container = styled.div<{ saleExp?: boolean, bg?: string[] }>`
  ${({ theme }) => theme.typography.bodySmall};
  display: flex;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing.spacing40};
  background: ${({ saleExp, bg }) => (saleExp ? `linear-gradient(250deg, ${bg[0]}, ${bg[1]})` : 'none')};
  ${({ saleExp }) => saleExp && `
    overflow: hidden;
    border-radius: 4px;
  `}
`;

export const Currency = styled.span`
  margin-right: ${({ theme }) => theme.spacing.spacing10};
`;

export const Amount = styled.span`
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.subTitleMedium};
  display: flex;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.subTitleLarge};
  }
`;

export const OriginalPrice = styled(Amount)`
  text-decoration: line-through;
  color: ${({ theme }) => theme.colors.textDisabled};
  margin-left: ${({ theme }) => theme.spacing.spacing20};
  ${({ theme }) => theme.typography.bodySmall};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.subTitleLarge};
  }
`;

export const Discount = styled.span`
  margin-left: ${({ theme }) => theme.spacing.spacing20};
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ theme }) => theme.colors.positive};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodyLarge};
  }
`;

export const Text = styled(GradientText) <{ gradientColors: string[] }>`
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const AnimatedPriceContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 24px;
  display: flex;
  align-items: center;
`;

export const AnimatedText = styled.div<{
  isVisible: boolean;
  animationDelay?: number;
}>`
  position: absolute;
  top: 0;
  left: 4px;
  width: calc(100% - 4px);
  height: 100%;
  display: flex;
  align-items: center;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  transform: translateY(100%); /* Always start from bottom */
  
  /* When visible, animate from bottom to center */
  ${({ isVisible }) => isVisible && `
    animation: slideUpFromBottom 0.4s ease-in-out forwards;
  `}
  
  /* When exiting, animate from center to top */
  &.exit {
    animation: slideUpToTop 0.3s ease-in-out forwards !important;
  }
  
  @keyframes slideUpFromBottom {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0%);
      opacity: 1;
    }
  }
  
  @keyframes slideUpToTop {
    from {
      transform: translateY(0%);
      opacity: 1;
    }
    to {
      transform: translateY(-100%);
      opacity: 0;
    }
  }
`;